import React from "react";
import "./about.css"
import ME from "../../assets/foto2.jpg"
import{RiMedal2Fill} from "react-icons/ri"
import{AiOutlineUser} from "react-icons/ai"
import{BsFolder} from "react-icons/bs"


const About =() => {
    return (
        <section id="about">
            <h5>conoceme</h5>
            <h2>sobre mi</h2>

            <div className="container about__container">
                <div className="about__me">
                    <div className="about__me-image">
                        <img src={ME} alt="About image"/>
                    </div>
                </div>

                <div className="about__content">
                    <div className="about__cards">
                        <article className="about__card">
                            <RiMedal2Fill className="about__icon"/>
                            <h5>Experiencia</h5>
                            <small>3+ años </small>
                        </article>
                        <article className="about__card">
                            <AiOutlineUser className="about__icon"/>
                            <h5>Clientes</h5>
                            <small>+200 clientes satisfechos</small>
                        </article>
                        <article className="about__card">
                            <BsFolder className="about__icon"/>
                            <h5>proyectos</h5>
                            <small>+100 trabajos </small>
                        </article>
                    </div>
                    <p>
                    "Soy Bryan, un ingeniero de software apasionado con experiencia en el desarrollo de soluciones tecnológicas innovadoras. Con conocimientos en Java, Python y JavaScript, y siguiendo los principios de desarrollo ágil, entrego soluciones de calidad en tiempo y forma. Me destaco por mi enfoque centrado en el usuario y mi habilidad para trabajar en equipos multidisciplinarios. Mi objetivo es crear experiencias excepcionales y soluciones intuitivas que cumplan con las necesidades de los usuarios finales."
                    </p>

                    <center><a href="#contacto" className="btn btn-primary">HABLAME</a></center>
                </div>
            </div>
        </section>
    )
}

export default About;